import { AUTH_STATE_KEY, AuthState } from './auth-reducer';

export enum AUTH_ACTION_TYPE {
  SET_STATE = 'AUTH/SET_STATE',
  LOGIN_REQUEST = 'AUTH/LOGIN_REQUEST',
  LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS',
  LOGIN_ERROR = 'AUTH/LOGIN_ERROR',
  LOGOUT = 'AUTH/LOGOUT',
  CHECK_AUTHORIZATION = 'AUTH/CHECK_AUTHORIZATION',
}

export type SetAuthStateAction<KeyName extends keyof AuthState> = {
  type: AUTH_ACTION_TYPE.SET_STATE;
  payload: { key: KeyName, value: AuthState[KeyName] };
};

export type LoginRequestAction = {
  type: AUTH_ACTION_TYPE.LOGIN_REQUEST;
};

export type LoginSuccessAction = {
  type: AUTH_ACTION_TYPE.LOGIN_SUCCESS;
  payload: { data: any };
};

export type LoginErrorAction = {
  type: AUTH_ACTION_TYPE.LOGIN_ERROR;
};

export type LogoutAction = {
  type: AUTH_ACTION_TYPE.LOGOUT;
};

export type CheckAuthorizationAction = {
  type: AUTH_ACTION_TYPE.CHECK_AUTHORIZATION;
};

export type AuthActions = SetAuthStateAction<AUTH_STATE_KEY> | LoginRequestAction | LoginSuccessAction | LoginErrorAction |
  LogoutAction | CheckAuthorizationAction;
